import { NgTemplateOutlet } from '@angular/common';
import { Component, LOCALE_ID, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { format } from 'date-fns';
import { enUS, hu } from 'date-fns/locale';
import { Tile } from '../../models/statistics';
import { ScrollFadeDirective } from '../../table/directives/scroll-fade.directive';
import { FormatDatePipe } from '../../table/pipes/format-date.pipe';
import { DonutChartComponent } from '../donut-chart/donut-chart.component';
import { GoogleMapsComponent } from '../google-maps/google-maps.component';
import {
  GoogleMapsInput,
  NON_INTERACTIVE_GOOGLE_MAPS_OPTIONS,
} from '../google-maps/model/google-maps-input.interface';
import { FormatNumberPipe } from '../pipes/format-number.pipe';
import { FormatUnitPipe } from '../pipes/format-unit.pipe';

@Component({
  selector: 'pozi-tile',
  imports: [
    RouterLink,
    NgTemplateOutlet,
    FormatDatePipe,
    DonutChartComponent,
    FormatNumberPipe,
    FormatUnitPipe,
    GoogleMapsComponent,
    ScrollFadeDirective,
  ],
  templateUrl: './tile.component.html',
  styleUrl: './tile.component.scss',
})
export class TileComponent {
  private locale = inject(LOCALE_ID);

  tile = input.required<Tile>();

  nonInteractiveGoogleMapsOptions = NON_INTERACTIVE_GOOGLE_MAPS_OPTIONS;

  /**
   * Memoized, like `tile-grid`'s `googleMapsInputMap`: bound from the template, a method
   * would hand `pozi-google-maps` a new object on every change-detection pass.
   */
  readonly googleMapsInput = computed<GoogleMapsInput>(() => ({
    drawings: this.tile()?.innerMapDrawings,
    grayscale: true,
  }));

  getDay(date: string | Date): string {
    return format(date, 'EEEE', {
      locale: this.locale === 'hu' ? hu : enUS,
    });
  }
}
